import { useCampaignContext } from "../contexts/CampaignContext"; // <-- changed from "@/contexts/..."
export function useCampaignId(explicit?: string | null) {
  const { campaign } = useCampaignContext();
  return explicit ?? campaign?.id ?? null;
}
